import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error || '로그인에 실패했습니다.');
    }
    setLoading(false);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-muted/50">
      <form onSubmit={handleLogin} className="bg-card p-8 rounded-lg shadow-lg w-96 border border-border">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-foreground">U3P 관리자 로그인</h2>
          <p className="text-sm text-muted-foreground mt-1">결제 플랫폼 관리 시스템</p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">이메일</label>
            <input
              type="email"
              placeholder="admin@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full p-2.5 border border-border rounded-md bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-primary outline-none"
              required
              disabled={loading}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">비밀번호</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full p-2.5 border border-border rounded-md bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-primary outline-none"
              required
              minLength={6}
              disabled={loading}
            />
          </div>

          {error && (
            <div className="bg-destructive/10 text-destructive px-3 py-2 rounded-md text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary text-primary-foreground p-2.5 rounded-md font-medium hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login;
